import React from "react";
import { Card } from "../modules/Settings/PackageSizes";

export function PackageCardPage(props) {
  return <Card {...props} />;
}
